<template>
  <div class="wgtSettings">
    <div class="cardR">
      <div class="boxR">
        <div class="fc myZoomClass" id="changeSnap" style="height: 100%;">
          <div class="content-panel1" v-show="isbumpErr">
            <apiErrorComponent @tryReload="tryReload" compTitle="" compId="changeChartDiv">
            </apiErrorComponent>
          </div>
          <div class="content-panel1" id="changeChartDiv" v-show="!isbumpErr">
            <div class="insideL  hide-on-presentation ">
              <div class="icon">
                <font-awesome-icon icon="fa-solid fa-bars" />
              </div>
              <div class="contents">
                <span v-show="!isbumpErr">
                  <font-awesome-icon icon="fa-solid fa-chalkboard-teacher" title="Add to Storyboard"
                    v-on:click="addToSlider()" />
                  <font-awesome-icon icon="fa-solid fa-file-download" title="Download Widget"
                    v-on:click="downloadDom()" />
                </span>
              </div>
            </div>
            <div class="insideR hide-on-presentation">
              <div class="icon">
                <font-awesome-icon icon="fa-solid fa-info" />
              </div>
              <div class="contents">
                {{ $parent.widgetInfo.bump_view }}
                <br />
                <br />
                Actions you can take on this widget: <br />
                <ul>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-chalkboard-teacher" /> to
                    add to storyboard
                  </li>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-file-download" /> to
                    download the chart with current insight
                  </li>

                </ul>
              </div>
            </div>
            <div v-show="!isbumpLoad">
              <widgetLoadingComp></widgetLoadingComp>
            </div>
            <div v-show="isbumpLoad" class="settingDiv"></div>
            <div class="row">
              <div class="col-4"></div>
              <div class="col-4">
                <VueMultiselect class="mymultiselect  hide-on-presentation " openDirection="bottom" v-model="changeOp" :options="bumpFilteron"
                  :multiple="false" :allow-empty="false" selectLabel="" deselect-label="can't Deselect"
                  :close-on-select="true" @select="getBumpChart" placeholder="Pick" track-by="name" label="name" />
              </div>
              <div class="col-4 text-end left-side-btn">
              </div>
            </div>
            <div class="panel-body text-center" id="renderBumps" style="height: 100%; padding-top: 0; padding-bottom:0;">
              <div id="bumpsChartHdr" v-show="isbumpShw" style="height: 100%;">
              </div>
              <div v-if="isbumpData" class="widgetError text-center">
                <widgetDataMsg></widgetDataMsg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
var dataBump
import {
  useRoute
} from 'vue-router';
import * as echarts from 'echarts';
import widgetDataMsg from '../smallcomp/chartDataMsg.vue'
import widgetLoadingComp from '../smallcomp/widgetloader.vue'
import domtoimage from "dom-to-image-more";
import screenShotMix from "./../../mixin/screenShotMix";
import apiErrorComponent from '../smallcomp/apierror.vue'
import {
  saveAs
} from 'file-saver';
var myChartBumps, months;
function reportWindowSizeBump() {
  if (myChartBumps != undefined) {
    myChartBumps.resize();
  }
}
export default {
  name: 'BumpView',
  mixins: [screenShotMix],
  props: {
    getpass: Object,
    getPins: Object,
    tabname: String,
  },
  components: {
    widgetLoadingComp,
    widgetDataMsg,
    apiErrorComponent
  },
  data() {
    return {
      changeOp: this.getpass.changeOp[0],
      bumpFilteron: this.getpass.bumpFilteron,
      isbumpErr: false,
      isbumpData: false,
      isbumpLoad: false,
      isbumpShw: false,
      IsbumpInsErr: false,
    }
  },
  methods: {
    tryReload() {
      let chkFilterOn = this.bumpFilteron.find(element => element.ticked == true)
      if (chkFilterOn != undefined && chkFilterOn.name == this.changeOp.name) {
        this.getBumpChart(this.changeOp)
      } else {
        this.getBumpChart(chkFilterOn)
      }
    },
    addToSlider() {
      let insArr = [];
      let name = "Bump Chart - " + this.getPins.viewName;
      let screenShort = {
        id: 'changeSnap',
        name: 'changeSnap.png'
      }
      this.addToSliderMix(screenShort, insArr, name)
    },
    drawBump(data, ranks) {
      var chartDom = document.getElementById('bumpsChartHdr');
      if(chartDom == null) return;
      if (chartDom != null && chartDom != undefined) {
        if (myChartBumps != null || myChartBumps != undefined) {
          echarts.dispose(chartDom)
        }
        myChartBumps = echarts.init(chartDom);
        var option;
        data.months = []
        let arrLegend = []
        let parallelAxisArr = []
        let seriesArr = []
        for (let index = 0; index < data.length; index++) {
          const element = data[index];
          if (!arrLegend.includes(element.club)) {
            arrLegend.push(element.club)
          }
          if (!data.months.includes(element.year)) {
            data.months.push(element.year)
          }
        }
        let currMon = data[0].year;
        let myJsonArr = []
        let myMonthArr = []
        for (let index = 0; index < data.length; index++) {
          const element = data[index];
          if (element.year != currMon) {
            myJsonArr.push({
              month: currMon,
              data: myMonthArr
            })
            currMon = element.year
            myMonthArr = []
            myMonthArr.push(element.club)
          } else {
            myMonthArr.push(element.club)
          }
        }
        myJsonArr.push({
          month: currMon,
          data: myMonthArr
        })
        months = myJsonArr;
        for (let index = 0; index < data.months.length; index++) {
          const element = data.months[index];
          parallelAxisArr.push({
            dim: index,
            min: 1,
            max: ranks,
            splitNumber: ranks,
            name: element,
            inverse: true
          })
        }
        for (let index = 0; index < arrLegend.length; index++) {
          const element = arrLegend[index];
          let arrSeries = [],
            ticketArr = [];
          for (let index = 0; index < myJsonArr.length; index++) {
            const element1 = myJsonArr[index];
            if (element1.data.includes(element)) {
              arrSeries.push(element1.data.indexOf(element) + 1)
            } else {
              arrSeries.push('-')
            }
          }
          seriesArr.push({
            name: element,
            type: 'parallel',
            symbolSize: 8,
            lineStyle: {
              width: 2,
              opacity: 0.75
            },
            emphasis: {
              lineStyle: {
                width: 3,
                opacity: 1
              },
            },
            data: [arrSeries]
          })
        }
        option = {
          parallelAxis: parallelAxisArr,
          tooltip: {
            trigger: 'item',
            confine: true,
            formatter: (params) => {
              let formatter = "";
              for (let index = 0; index < months.length; index++) {
                const element = months[index];
                let ticCount = "-"
                for (let index1 = 0; index1 < dataBump.length; index1++) {
                  const element11 = dataBump[index1];
                  if (element11.club == params.seriesName && element11.year == element
                    .month) {
                    ticCount = element11.points;
                  }
                }
                if (ticCount != "-") {
                  formatter += " " + element.month + " in position " + params.data[
                    index] + " : # tickets " + ticCount + "<br />";
                } else {
                  formatter += " " + element.month + " in position > 10<br />";
                }
              }
              return params.seriesName + "<br /> " + formatter;
            },
          },
          legend: {
            display: true,
            bottom: 30,
            data: arrLegend,
            type: 'scroll',
            itemGap: 10,
            textStyle: {
              color: '#777'
            }
          },
          parallel: {
            left: '5%',
            right: '5%',
            bottom: 130,
            parallelAxisDefault: {
              type: 'value',
              nameLocation: 'end',
              nameGap: 20,
              nameTextStyle: {
                color: '#777',
                fontSize: 12
              },
              axisLine: {
                lineStyle: {
                  color: '#777'
                }
              },
              axisTick: {
                lineStyle: {
                  color: '#777'
                }
              },
              splitLine: {
                show: false
              },
              axisLabel: {
                color: '#777'
              }
            }
          },
          series: seriesArr
        };
        option && myChartBumps.setOption(option);
      }
    },
    getBumpChart(changeOp) {
      if (changeOp != "") {
        changeOp = changeOp.dbname
      }
      this.axios.post(this.uriApiUrl + 'DataAnalysis/bump_view?asg_id=' + this.asgId, {
        "filterlevel": changeOp,
        "selid": this.getPins.selid,
        "edited": this.getPins.edited
      },{
      headers: {
            'Content-Type': 'application/json'
          }})
        .then((response) => {
          if (response.status == 200) {
            if (response.data != "Error" && response.data != "Nodata") {
              dataBump = response.data.chart
              this.isbumpShw = true
              setTimeout(() => {
                this.drawBump(dataBump, response.data.count)
              }, 100)
            } else if (response.data == "Nodata") {
              this.isbumpData = true
            } else {
              this.isbumpErr = true
              this.$notify({
                type: "error",
                text: 'Sorry! Something went wrong in Bumpview Trend. Try after sometime!'
              })
            }
            this.isbumpLoad = true
          }
        }).catch((response) => {
          this.isbumpErr = true
          this.isAnalysisload = false
          if (this.enabledDebug == 1) {
            this.$notify({
              type: "error",
              text: 'Sorry! Something went wrong in Bumpview Trend. Try after sometime!'
            })
          }
        })
    },
    downloadDom() {
      let imgname = "Bump_Chart.png"
      let widgetID = "changeSnap"
      var geticondiv = document.querySelectorAll('#changeSnap .insideL,#changeSnap .insideR, .hide-on-presentation')
      geticondiv.forEach(box => {
        box.style.opacity = 0;
      });
      document.getElementById(widgetID).classList.remove("myZoomClass")
      domtoimage.toBlob(document.getElementById(widgetID))
        .then(function (blob) {
          saveAs(blob, imgname)
          geticondiv.forEach(box => {
            box.style.opacity = 1;
          });
          document.getElementById(widgetID).classList.add("myZoomClass")
        })
    },
  },
  mounted() {
    const route = useRoute()
    this.asgId = route.params.asgid
    let chkFilterOn = this.bumpFilteron.find(element => element.ticked == true)
    if (chkFilterOn != undefined && chkFilterOn.name == this.changeOp.name) {
      this.getBumpChart(this.changeOp)
    } else {
      this.getBumpChart(chkFilterOn)
    }
    window.addEventListener("resize", reportWindowSizeBump);
  },
  unmounted() {
    window.removeEventListener("resize", reportWindowSizeBump);
  },
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.wgtSettings {
  min-height: 940px;
}

.wgtSettings .cardR {
  min-height: 920px;
  width: 100%;
}

.wgtSettings .cardR .content-panel1 {
  min-height: 100%;
}

.cardR .boxR {
  height: 100%;
}</style>